import React, { useEffect, useRef, useState } from 'react';

import './LowerThirds.scss';
import './BrandSettings.scss';
import { useDispatch, useSelector } from 'react-redux';

import { TemplateService} from '../../../services/template-service';
import { container } from 'tsyringe';
import { useSharedState } from '../../../utils/helpers';
import { REPLACE_LOWERTHIRD_IN_TEMPLATES, ADD_TEMPLATE, REMOVE_TEMPLATE, SELECT_LOWERTHIRD, REMOVE_TEMPLATE_TYPE } from '../../../redux/templates/templateReducer';
import { Template, TemplateType } from '../../../models/templateClass';

import { BrandTheme } from './BrandSettings';

import * as R from 'ramda';
import { ApiService } from '../../../services/api-service';
import NewLabel from '../../newLabel/NewLabel';
import ColorSelector from '../../utils/ColorSelector';

import DOMPurify from "dompurify";
import { ActionType, GroupType } from '../../../models/actionClass';
import { MediaOrigin } from '../../../models/mediaClass';
import { SoundKey, SoundService } from '../../../services/sound-service';

const LowerThirds = () => {

  const [apiService] = useState(container.resolve(ApiService));

  const [templateService] = useState(container.resolve(TemplateService));
  const [lowerthirds, setLowerthirds] = useSharedState(templateService.lowerthirds$);
  const [selectedLowerthird, setSelectedLowerThird] = useSharedState(templateService.selectedLowerthird$);


  const [editingLT, setEditingLT] = useState(null);

  const brandsettings = useSelector((state: any) => state.templates.brandsettings);

  const selectedLowerThirdInStore = useSelector((state: any) => state.templates.selectedLowerThird);

  const dispatch = useDispatch();

  const addLT = () => {
    apiService.toggleRegisterPopup();

    // if (!editingLT) {

    //   console.log('add a new LT');
    //   // setLowerthirds(templateService.addDefault(TemplateType.T_LOWERTHIRD));
    //   const newLT = templateService.addDefault(TemplateType.T_LOWERTHIRD);
    //   if (newLT) {
    //     newLT.primaryColor = brandsettings.primaryColor;
    //     setEditingLT(newLT);
    //   }
    // } else {
    //   handleCancel(editingLT);
    // }
  }

  const editLT = (lt) => {
    if (!editingLT) {
      console.log('edit a LT / work on a clone');
      setEditingLT(R.clone(lt));
    }
  }

  const handleCancel = (lt) => {
    if (lt.isAdding) {
      templateService.remove(TemplateType.T_LOWERTHIRD, lt.id, MediaOrigin.PREDEFINED);
    }
    setEditingLT(null);
  }

  const handleCreate = (lt) => {
    lt.isNew = true;
    lt.selected = false;
    templateService.save(TemplateType.T_LOWERTHIRD, lt);
    setEditingLT(null);
  }

  useEffect(() => {
    console.log('lowerthirds updated', lowerthirds);
    if (selectedLowerthird && selectedLowerthird.length>0) {
      for(const lthird of lowerthirds) {
        if (lthird.id === selectedLowerthird) {
          // find matching lowerthird in store
          dispatch({type: SELECT_LOWERTHIRD, payload: lthird});
          dispatch({type: REPLACE_LOWERTHIRD_IN_TEMPLATES, payload: lthird})
        }
      }
    } else {
      // no lowerthird selected
      dispatch({type: SELECT_LOWERTHIRD, payload: null});
      dispatch({type: REMOVE_TEMPLATE_TYPE, payload: {type: TemplateType.T_LOWERTHIRD}} );
    }

  }, [selectedLowerthird]);

  useEffect(() => {
    console.log('lowerthrids', lowerthirds);
    const selectedLT = lowerthirds.find(lt => lt.selected);
    if (selectedLT) {
      console.log("found a selected LT", selectedLT);
      setSelectedLowerThird(selectedLT.id);
    }
  }, [lowerthirds]);


  console.log("%%% LOWERTHIRDS", lowerthirds);

  return (
    <>
    <div className={"ButtonAdd ButtonIdle"} onClick={(e) => addLT()}></div>

    { editingLT &&
      <LowerThirdEdit lowerthird={editingLT} handleCancel={(lt) => handleCancel(lt)} handleCreate={(lt) => handleCreate(lt)}></LowerThirdEdit>
    }

    <ul className="lowerthirds">
      {
        lowerthirds.filter(lt => !lt.isAdding).map( lt =>
          <li key={lt.id} id={lt.id} className="lowerthird">
            <LowerThird lt={lt} selectedLowerThirdInStore={selectedLowerThirdInStore} editLT={(lt) => editLT(lt)}></LowerThird>
          </li>
        )
      }
    </ul>
    </>
  );
}

interface LTEditProps {
  lowerthird: Template;
  handleCancel: any;
  handleCreate: any;
}

const LowerThirdEdit = (props: LTEditProps) => {
  const newLT = props.lowerthird;

  const inputPrimaryText = useRef();
  const [firstTime, setFirstTime] = useState(true);

  const [apiService] = useState(container.resolve(ApiService));

  const [primaryText, setPrimaryText] = useState(newLT.primaryText);
  const [secondaryText, setSecondaryText] = useState(newLT.secondaryText);
  const [primaryColor, setPrimaryColor] = useState(newLT.primaryColor);

  const selectedTheme = useSelector((state: any) => state.templates.brandsettings.selectedTheme);


  if (!newLT) {
    return (<></>);
  }

  const onColorSelect = (hex) => {
    setPrimaryColor(hex);
    newLT.primaryColor = hex;
    apiService.updateReason = {group: GroupType.LOWERTHIRD, action: ActionType.PRIMARYCOLOR, id: newLT.id, value: newLT.primaryColor };

  }

  const handleCancel = () => {
    console.log('CANCEL NEW LT');
    props.handleCancel(newLT);
  }

  const handleCreate = () => {
    console.log('CREATE NEW LT', newLT);
    apiService.updateReason = {group: GroupType.LOWERTHIRD, action: ActionType.ADD, id: newLT.id, value: newLT };

    props.handleCreate(newLT);
  }

  const setPrimary = (event) => {
    const text = DOMPurify.sanitize(event.target.value);
    console.log(text);
    setPrimaryText(text);
    newLT.primaryText = text;
    apiService.updateReason = {group: GroupType.LOWERTHIRD, action: ActionType.PRIMARYTEXT, id: newLT.id, value: text };

  }

  const setSecondary = (event) => {
    const text = DOMPurify.sanitize(event.target.value);
    setSecondaryText(text);
    newLT.secondaryText = text;
  }

  if (firstTime) {
    setFirstTime(false);
    setTimeout(() => {
      if (inputPrimaryText.current) (inputPrimaryText.current as HTMLInputElement).focus();
    }, 100);
  }

  return (
    <div className="lowerthirds-editor">
      <div className="card brandsettings">
        <div className="left">
          <div className="lt-color">
            <div className='title'>Color Fill</div>
            <ColorSelector primaryColor={newLT.primaryColor} onColorSelect={(c) => onColorSelect(c)}></ColorSelector>
          </div>
          <div className="text primary">
            <input value={primaryText} onChange={(e) => setPrimary(e)} className="lowerthird-text_input" maxLength={120} placeholder="Primary Long Text" ref={inputPrimaryText} />
          </div>
          <div className="text secondary">
            <input value={secondaryText} onChange={(e) => setSecondary(e)} className="lowerthird-text_input" maxLength={120} placeholder="Secondary Text"/>
          </div>
        </div>

        <div className="right themes">
          <BrandTheme primaryColor={primaryColor} primaryText={primaryText} secondaryText={secondaryText} theme={selectedTheme} selectTheme={null}></BrandTheme>
        </div>
      </div>

      <div className="button-footer">
          <button onClick={handleCancel} className="btn-cancel">Cancel</button>
          <button onClick={handleCreate} className="btn-with-gradient">{ newLT.isAdding ? "CREATE" : "SAVE" }
          </button>
      </div>

    </div>
  );
}

interface LTProps {
  lt: Template;
  selectedLowerThirdInStore: Template;
  editLT: any;
}
const LowerThird = (props: LTProps) => {

  const lt = props.lt;
  const selectedLowerThirdInStore = props.selectedLowerThirdInStore;

  const [soundService] = useState(container.resolve(SoundService));

  const [templateService] = useState(container.resolve(TemplateService));
  const [lowerthirds, setLowerthirds] = useSharedState(templateService.lowerthirds$);

  const apiService: ApiService = container.resolve(ApiService);

  console.log('lt', lt);

  const dispatch = useDispatch();

  const IsSelected = (lt) => {
    return (lt.id === selectedLowerThirdInStore?.id);
  }

  const onSelect = (lt) => {

    if (lt.id === selectedLowerThirdInStore?.id) {
      // already selected => do nothing
      onHide(lt);
      return;
    }

    dispatch({type: SELECT_LOWERTHIRD, payload: lt});
    dispatch({type: REPLACE_LOWERTHIRD_IN_TEMPLATES, payload: lt})

    const newLowerthirds = R.clone(lowerthirds);
    const newlt = newLowerthirds.find(l => l.id === lt.id);
    newLowerthirds.forEach(l => l.selected = false);
    if (newlt) {
      newlt.selected = true;
      newlt.isNew = false;
    }
    setLowerthirds(newLowerthirds);

    apiService.forceLayerSend = true;
    apiService.updateReason = {group: GroupType.LOWERTHIRD, action: ActionType.SELECT, id: lt.id};

  }

  const onHide = (lt) => {
    if (!selectedLowerThirdInStore) {
      return;
    }

    dispatch({type: SELECT_LOWERTHIRD, payload: null});
    dispatch({type: REMOVE_TEMPLATE, payload: {id: lt.id}} );

    const newLowerthirds = R.clone(lowerthirds);
    newLowerthirds.forEach(l => l.selected = false);
    setLowerthirds(newLowerthirds);
    apiService.forceLayerSend = true;
    apiService.updateReason = {group: GroupType.LOWERTHIRD, action: ActionType.UNSELECT, id: lt.id};
  }

  const editLT = (lt) => {
    if (IsSelected(lt)) { return ;}
    if (props.editLT) {
      props.editLT(lt);
    }
  }


  const deleteLT = (lt) => {
    if (IsSelected(lt)) { return ;}

    templateService.remove(TemplateType.T_LOWERTHIRD, lt.id, MediaOrigin.PREDEFINED);
    dispatch({type: REMOVE_TEMPLATE, payload: {id: lt.id}} );
    apiService.updateReason = {group: GroupType.LOWERTHIRD, action: ActionType.REMOVE, id: lt.id};

    soundService.playSoundStart(SoundKey.Trash)

  }

  return (
    <div className="lowerthird-container">
    { lt.isNew &&
      <NewLabel></NewLabel>
    }
    <div className={'ButtonShow ' + ( IsSelected(lt) ? "ButtonShow-On" : "ButtonShow-Off" )} onClick={() => onSelect(lt)}/>

      <div className='lowerthird-fields'>
        <div key="primary" className="primaryText">{lt.primaryText}</div>
        <div key="secondary" className="secondaryText">{lt.secondaryText}</div>
      </div>

      {!IsSelected(lt) &&
      <>
      <div className="Icon IconEdit" onClick={() => editLT(lt)}></div>

      <div className="Icon IconTrashCan" onClick={() => deleteLT(lt)}></div>
      </>
      }
    </div>
  )
}




export default LowerThirds;